import axios from "axios";
import { catchAsync } from "../catchAsync";

export const attachClassToPsych = async (classId) => {
    return catchAsync(async () => {
        const { data } = await axios.patch(`/classes/${classId}/attach`);
        return data;
    });
};
